/* eslint-disable no-unused-vars */

/* eslint-disable no-unused-expressions */

/* eslint-disable func-names */

/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_CATEGORY_URL, API_MEDIA_URL, COMMON_HEADER_CONFIG} from "src/config";

class CategoryService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListCategory = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CATEGORY_URL}/categories`,
        params: {
          size: null,
          page: 1,
          sort: "cat_order asc",
          channel: "bipbipapp", // #TODO: currently, we get only category data by bipbipapp channel
          ...params
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createOneCategory = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_CATEGORY_URL}/category`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneCategory = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CATEGORY_URL}/category/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateCategory = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_CATEGORY_URL}/category/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteCategory = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_CATEGORY_URL}/category/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  uploadImage = (presignedPostData, file) =>
    new Promise((resolve, reject) => {
      const formData = new FormData();
      Object.keys(presignedPostData.fields).forEach((key) => {
        formData.append(key, presignedPostData.fields[key]);
      });

      // Actual file has to be appended last.
      formData.append("file", file);

      const xhr = new XMLHttpRequest();
      xhr.open("POST", presignedPostData.url, true);
      xhr.send(formData);
      xhr.onload = function (response) {
        this.status === 204 ? resolve("success") : reject(response);
      };
    });

  preUpload = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_MEDIA_URL}/uploads/pre_up`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  moveCategoryPriority = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_CATEGORY_URL}/category-update`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createUpload = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_MEDIA_URL}/uploads/create`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListCategoryByLevel = (level, type) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CATEGORY_URL}/categories`,
        params: {
          size: 100,
          page: 1,
          level,
          type
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const categoryService = new CategoryService();

export default categoryService;
